export default defineNuxtPlugin(() => {
  let loaded = false

  const loadChat = () => {
    if (loaded) return
    loaded = true

    events.forEach((event) =>
      window.removeEventListener(event, loadChat, { capture: true } as EventListenerOptions)
    )
    clearTimeout(fallbackTimer)

    const script = document.createElement('script')
    script.id = 'script-infochat'
    script.src =
      'https://cdn.asksuite.com/infochat.js?dataConfig=https://control.asksuite.com/api/companies/salamis-bay-conti-resort-hotel'
    script.async = true
    document.head.appendChild(script)
  }

  // Asksuite injects a promo bubble that can end up as the page's Largest
  // Contentful Paint element. LCP stops being measured once the user
  // interacts with the page, so loading the widget on first interaction
  // (instead of a fixed timer) keeps it from ever being picked as the LCP.
  const events: (keyof WindowEventMap)[] = ['scroll', 'mousemove', 'keydown', 'touchstart', 'click']
  events.forEach((event) =>
    window.addEventListener(event, loadChat, { passive: true, capture: true })
  )

  // Fallback so the widget still loads for users who never interact.
  const fallbackTimer = setTimeout(loadChat, 10000)
})
